

























import { defineComponent } from "@vue/composition-api";

export default defineComponent({
  name: "RepetitionsSwitch",
  props: {
    value: { type: Boolean }
  }
});
